import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import Button from '../components/ui/Button';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary-50">
      <div className="text-center max-w-md px-4">
        <h1 className="text-9xl font-bold text-secondary-300 mb-4">404</h1>
        <h2 className="text-3xl font-bold mb-4 text-secondary-900">Page introuvable</h2>
        <p className="text-secondary-600 mb-8 text-lg">
          Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        <Link to="/">
          <Button size="lg" icon={<Home size={20} />}>
            Retour à l'accueil
          </Button>
        </Link>
      </div>
    </div>
  );
}
